(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kw-graphene-step-clips"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-kw-graphene-steps]').forEach(root => {
  const dialog = root.querySelector('dialog');
  const player = root.querySelector('[data-kw-step-player]');
  const title = root.querySelector('[data-kw-step-title]');
  let opener;
  root.querySelectorAll('[data-kw-step-trigger]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      if (!dialog.showModal) return;
      event.preventDefault();
      opener = trigger;
      title.textContent = trigger.dataset.title;
      player.setAttribute('aria-label', trigger.dataset.title);
      player.poster = trigger.dataset.poster;
      player.src = trigger.href;
      dialog.showModal();
      player.play().catch(() => {});
    });
  });
  root.querySelector('[data-kw-step-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    if (opener) opener.focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
